module.exports = __webpack_public_path__ + "img/6.768c5edf.jpg";